import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/core/services/auth.guard';
import { AuthLayotComponent } from './authorization/auth-layout/auth-layout.component';
import { DeepLinkComponent } from './deeplink/deeplink.component';
import { LayoutComponent } from './shared/layout/layout.component';
import { HomePageComponent } from './shared/pages/home-page/home-page.component';
import { NotFoundComponent } from './shared/pages/not-found/not-found.component';

const routes: Routes = [
    {
        path: 'dashboard',
        component: LayoutComponent,
        data: { title: 'Dashboard' },
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(mod => mod.DashboardModule)
            },
        ]
    },
    {
        path: 'home',
        component: LayoutComponent,
        data: { title: 'Home' },
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                component: HomePageComponent
            }
        ]
    },
    {
        path: '',
        component: AuthLayotComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./authorization/authorization.module').then(mod => mod.AuthorizationModule)
            },
        ]
    },
    {
        path: 'uri',
        component: DeepLinkComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./deeplink/deeplink.module').then(mod => mod.DeepLinkModule)
            },
        ]
    },
    { path: 'remove-user', loadChildren: () => import('./remove-user/remove-user.module').then(m => m.RemoveUserModule) },
    { path: '**', redirectTo: '/404' },
    {
        path: '404',
        data: { title: '404' },
        component: NotFoundComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
